import styled from "styled-components";

export const MobileMenuFixedStyled = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    
    box-shadow: 0 0 25px rgb(0 0 0 / 25%);
    background: var(--color-surface);
    z-index: 9;
`;

export const MobileMenuStyled = styled.div`
    display: flex;
    flex-direction: row;
    
    a {
        color: unset;
        text-decoration: none;
    }
`;

export const MobileMenuItemStyled = styled.div`
    text-align: center;
    flex: 1;
    opacity: 0.5;
    color: #8192E4;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 0;
    
    a {
        display: block;
    }
    
    svg {
        fill: #8192E4;
    }
    
    &.active,
    &:hover {
        opacity: 1;
    }
`;
